<template>
  <v-form>
    <v-container>
      <span v-if="editMotorId == -1" class="headline">{{$t('create_motor')}}</span>
      <span v-if="editMotorId != -1" class="headline">{{$t('edit_motor')}}</span>
      <v-row>
        <v-col cols="12" lg="2" md="3" sm="4">
            <v-select v-model="motor.type" :items="motorTypes" :label="$t('motor.type')"></v-select>


        </v-col>

        <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="motor.power" suffix="HP" :label="$t('motor.power')" required></v-text-field>
        </v-col>

        <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="motor.powerKW" suffix="kW" :label="$t('motor.power')" required></v-text-field>
        </v-col>
         
      </v-row>

      <v-row>
        <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="motor.nominal_current" suffix="A" :label="$t('motor.nominal_current')" required></v-text-field>
        </v-col>

                <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field
            v-model="motor.axial_load_capacity"
            suffix="kN"
            :label="$t('pump.axial_load_capacity')"
            required
          ></v-text-field>
        </v-col>

         <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="motor.starting" suffix="" :label="$t('motor.start')" required></v-text-field>
        </v-col>
      </v-row>

      <!-- <v-row>
        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field
            v-model="motor.nominal_effiency"
            suffix="%"
            label="Nominal Effiency"
            required
          ></v-text-field>
        </v-col>



        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="motor.effiency" suffix="%" label="Effiency" required></v-text-field>
        </v-col>

        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="motor.load_rate" suffix="%" label="Load Rate" required></v-text-field>
        </v-col>
      </v-row>  -->

      <v-row>
       


        <!-- <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field
            v-model="motor.nominal_diameter"
            suffix="''"
            label="Nominal Diameter"
            required
          ></v-text-field>
        </v-col> -->

        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="motor.length" suffix="mm" :label="$t('motor.length')" required></v-text-field>
        </v-col>

        <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="motor.weight" suffix="kg" :label="$t('motor.weight')" required></v-text-field>
        </v-col>
      </v-row>
  <v-row>
       <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="motor.price" suffix="$" :label="$t('motor.price')" required></v-text-field>
        </v-col>
      </v-row>
      <div class="my-2">
        <v-btn v-if="editMotorId == -1" color="primary" @click="saveMotor">{{$t('save')}}</v-btn>
        <v-btn v-if="editMotorId != -1" color="primary" @click="saveMotor">{{$t('update')}}</v-btn>
        
      </div>
    </v-container>
  </v-form>
</template>

<script>
// const API_URL = "http://localhost:9090/";

export default {
  name: "HelloWorld",

  data: () => ({
    token: '',
    query: '',
    motorTypes: [],
    motor: {
      idmotor: -1,
      type: "",
      power: "",
      powerKW: "",
      nominal_diameter: "",
      nominal_current: "",
      length: "",
      weight: "",
      nominal_effiency: "",
      effiency: "",
      axial_load_capacity: "",
      price: "",
      starting: "Y - Δ",
      
    }
  }),

  props : {
    editMotorId: {
      type: String,
      default: '-1'
    }
  },

  mounted: function() {
    if(localStorage.token){
      this.token = localStorage.token
      this.$http.defaults.headers.common['Authorization'] = `Bearer ${this.token}` 
    }
      if ( this.editMotorId != -1){
        this.fetchMotor(this.editMotorId)
      }
      this.fetchMotorTypes()
  },

  methods: {
    fetchMotorTypes: function() {
      this.motorTypes = [];
      this.$http.get(this.$API_URL + "motor_types").then(result => {
        result.data.forEach(motorType => {
          this.motorTypes.push({
            text: motorType.type +", "+motorType.phase+" phase, "+motorType.voltage+" V, "+
            motorType.fi_d_max+" mm",
            value: motorType.idmotor_type
          });
        });
      });
    },
    fetchMotor: function(editMotorId) {
      this.$http.get(this.$API_URL + "motor?idmotor=" + editMotorId).then(result => {
        this.motor = result.data
      });
    },
    saveMotor: function() {
      var targetUrl = this.editMotorId == -1 ? "save_motor" : "update_motor";
      this.$http({
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        url: this.$API_URL + targetUrl,
        data: this.motor,
        query: {
          update: true
        }
      })
        .then(function(response) {
          if (response.data == "1")
             window.history.go(-1)
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>
